export enum FileExtensionEnum {
    EXCEL = '.xlsx',
    CSV = '.csv'
}